import { ResultColumn } from "./SearchResults";

export const composeItemDefs = (collection: string): ResultColumn[] => {
    switch (collection) {
        case "delwp-planning-ministerial-permits-stage":
        case "delwp-planning-ministerial-permits-prod":
            return [
                {
                    funnelbackField: "metaData.applicationID",
                    columnKey: "applicationId",
                },
                {
                    funnelbackField: "metaData.applicationNumber",
                    columnKey: "applicationNumber",
                    label: "Application number",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "liveUrl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.applicationReceivedDate",
                    columnKey: "applicationReceivedDate",
                    label: "Date received",
                    cellDisplay: "date",
                },
                {
                    funnelbackField: "metaData.applicationDescription",
                    columnKey: "applicationDescription",
                    label: "Description",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.address",
                    columnKey: "address",
                    label: "Address",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.determinationDecision",
                    columnKey: "determinationDecision",
                    label: "Decision",
                    cellDisplay: "combineMetadata",
                },
                {
                    funnelbackField: "metaData.determinationdateOfDecision",
                    columnKey: "determinationdateOfDecision",
                },
                {
                    funnelbackField: "metaData.applicationType",
                    columnKey: "applicationType",
                    label: "Type",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.isDFP",
                    columnKey: "isDfp",
                },
            ];
        case "delwp-search-listings-guide-resources-push":
        case "delwp-search-listings-strategies-initiatives-push":
        case "delwp-search-listings-data-insights-push":
        case "delwp-search-listings-council-resources-push":
            return [
                {
                    funnelbackField: "title",
                    columnKey: "resourceName",
                    label: "Resource name",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "metaData.canonicalurl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.intro",
                    columnKey: "description",
                    label: "Description",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.resourceType",
                    columnKey: "resourceType",
                    label: "Resource type",
                    cellDisplay: "badge",
                },
                {
                    funnelbackField: "status",
                    columnKey: "status",
                    label: "Status",
                    cellDisplay: "status",
                },
            ];
        case "delwp-search-listings-practice-notes-push":
            return [
                {
                    funnelbackField: "title",
                    columnKey: "resourceName",
                    label: "Resource name",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "metaData.canonicalurl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.intro",
                    columnKey: "description",
                    label: "Description",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.topic",
                    columnKey: "topic",
                    label: "Topic",
                    cellDisplay: "badge",
                },
            ];
        case "delwp-search-global-web":
            return [
                {
                    funnelbackField: "liveUrl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.resourceType",
                    columnKey: "resourceType",
                    label: "Resource type",
                    cellDisplay: "badge",
                },
                {
                    funnelbackField: "status",
                    columnKey: "status",
                    label: "Status",
                    cellDisplay: "status",
                },
                {
                    funnelbackField: "title",
                    columnKey: "resourceName",
                    label: "Resource name",
                    cellDisplay: "title",
                },
                {
                    funnelbackField: "liveUrl",
                    columnKey: "link",
                    label: "Link",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "metaData.c",
                    columnKey: "description",
                    label: "Description",
                    cellDisplay: "text",
                },
            ];
        case "delwp-search-listings-guides-push":
            return [
                {
                    funnelbackField: "title",
                    columnKey: "resourceName",
                    label: "Resource name",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "metaData.canonicalurl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.intro",
                    columnKey: "description",
                    label: "Description",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "status",
                    columnKey: "status",
                    label: "Status",
                    cellDisplay: "status",
                },
            ];
        case "delwp-search-listings-consultations-push":
        case "delwp-search-listings-consultations-push-stage":
            return [
                {
                    funnelbackField: "title",
                    columnKey: "resourceName",
                    label: "Name",
                    cellDisplay: "textLink",
                    cellClassName: "consultationsTitle",
                },
                {
                    funnelbackField: "metaData.canonicalurl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.type",
                    columnKey: "type",
                    label: "Type",
                    cellDisplay: "badge",
                    cellClassName: "consultationsType",
                },
                {
                    funnelbackField: "metaData.intro",
                    columnKey: "description",
                    label: "Description",
                    cellDisplay: "text",
                    cellClassName: "consultationsDescription",
                },
                {
                    funnelbackField: "status",
                    columnKey: "status",
                    label: "Status",
                    cellDisplay: "status",
                    cellClassName: "consultationsStatus",
                },
                {
                    funnelbackField: "metaData.openDate",
                    columnKey: "openDate",
                    label: "Open date",
                    cellDisplay: "date",
                    cellClassName: "consultationsDate",
                },
                {
                    funnelbackField: "metaData.closeDate",
                    columnKey: "closeDate",
                    label: "Close date",
                    cellDisplay: "date",
                    cellClassName: "consultationsDate",
                },
                {
                    funnelbackField: "metaData.externalLink",
                    columnKey: "isExternalLink",
                },
            ];
        case "delwp-search-glps-push":
            return [
                {
                    funnelbackField: "title",
                    columnKey: "site",
                    label: "Site",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "metaData.canonicalurl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.council",
                    columnKey: "council",
                    label: "Council",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.intro",
                    columnKey: "proposal",
                    label: "Proposal",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "status",
                    columnKey: "status",
                    label: "Status",
                    cellDisplay: "status",
                },
                {
                    funnelbackField: "metaData.stream",
                    columnKey: "stream",
                    label: "Stream",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.dateGazetted",
                    columnKey: "dateGazetted",
                    label: "Date gazetted",
                    cellDisplay: "date",
                },
            ];
        case "delwp-search-listings-ees-push-stage":
        case "delwp-search-listings-ees-push":
            return [
                {
                    funnelbackField: "title",
                    columnKey: "resourceName",
                    label: "Project Name",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "metaData.canonicalurl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "metaData.projectType",
                    columnKey: "projectType",
                    label: "Project type",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.referralAcceptedDate",
                    columnKey: "referralAcceptedDate",
                    label: "Referral accepted date",
                    cellDisplay: "date",
                },
                {
                    funnelbackField: "metaData.referralDecision",
                    columnKey: "referralDecision",
                    label: "Referral decision",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.type",
                    columnKey: "type",
                    label: "Assessment type",
                    cellDisplay: "text",
                },
                {
                    funnelbackField: "metaData.status",
                    columnKey: "status",
                    label: "Status",
                    cellDisplay: "status",
                },
            ];
        case "building-search-global-web":
            return [
                {
                    funnelbackField: "liveUrl",
                    columnKey: "url",
                },
                {
                    funnelbackField: "title",
                    columnKey: "resourceName",
                    label: "Resource name",
                    cellDisplay: "title",
                },
                {
                    funnelbackField: "liveUrl",
                    columnKey: "link",
                    label: "Link",
                    cellDisplay: "textLink",
                },
                {
                    funnelbackField: "summary",
                    columnKey: "description",
                    label: "Description",
                    cellDisplay: "text",
                },
            ];
        default:
            return [];
    }
};
